const translation = {
  // ===== FinancialModel 国际化 =====
  "FinancialModel.analysisSuffix": " - 财务分析",
  "FinancialModel.efficiencyAnalysis.coreStaffAnnualSalary": "核心人员年度薪资",
  "FinancialModel.efficiencyAnalysis.maAnnualSalary": "马总年薪",
  "FinancialModel.efficiencyAnalysis.liaoAnnualSalary": "廖工年薪",
  "FinancialModel.efficiencyAnalysis.totalAnnualLaborCost": "年度总人工成本",
  "FinancialModel.costStructure.cost_cloud": "云服务软件",
  "FinancialModel.costStructure.cost_labor": "人力成本",
  "FinancialModel.costStructure.cost_marketing": "市场与销售",
  "FinancialModel.costStructure.cost_misc": "杂项预备金",
  "FinancialModel.costStructure.cost_material": "研发材料设备",
  "FinancialModel.costStructure.cost_admin": "行政与合规",
  "FinancialModel.efficiencyAnalysis.totalProjects": "总项目数",
  "FinancialModel.efficiencyAnalysis.activeProjects": "进行中项目",
  "FinancialModel.efficiencyAnalysis.blockedProjects": "阻塞项目",
  "FinancialModel.efficiencyAnalysis.completedProjects": "已完成项目",
  "FinancialModel.efficiencyAnalysis.analysisDescriptionTitle": "项目分析说明",
  "FinancialModel.efficiencyAnalysis.analysisDescription":
    "{{totalProjects}}个项目任务，马总和廖工均为每月10,000元月薪基础。项目分析考虑了人员的项目参与度、任务优先级和项目完成情况，为项目管理决策提供数据支持。",
  "FinancialModel.efficiencyAnalysis.corePersonnelSalaryTitle":
    "核心人员年度薪资",
  "FinancialModel.efficiencyAnalysis.personMaSalary": "马总年薪:",
  "FinancialModel.efficiencyAnalysis.personLiaoSalary": "廖工年薪:",
  "FinancialModel.efficiencyAnalysis.totalLaborCost": "年度总人工成本:",
  "FinancialModel.efficiencyAnalysis.projectParticipationAnalysis":
    "项目参与度分析",
  "FinancialModel.efficiencyAnalysis.allTime": "全部时间",
  "FinancialModel.efficiencyAnalysis.taskStatus": "任务情况",
  "FinancialModel.efficiencyAnalysis.participation": "参与度",
  "FinancialModel.efficiencyAnalysis.completionRate": "完成率",
  "FinancialModel.monthlyAnalysis.monthlyExpenseTrend": "月度支出趋势",
  "FinancialModel.monthlyAnalysis.expenseAnalysisMethodology":
    "月度支出分析方法论",
  "FinancialModel.monthlyAnalysis.methodologyBaseCost":
    "• 基础成本：固定人员工资（马总、廖工各1万/月）",
  "FinancialModel.monthlyAnalysis.methodologyProjectExpense":
    "• 项目支出：基于活跃项目数量计算",
  "FinancialModel.monthlyAnalysis.methodologyExpenseCategory":
    "• 支出分类：人员成本和项目支出两大类",
  "FinancialModel.monthlyAnalysis.keyMetricsDescription": "关键指标说明",
  "FinancialModel.monthlyAnalysis.metricTotalExpense":
    "• 月度总支出 = 人员成本 + 项目支出",
  "FinancialModel.monthlyAnalysis.metricLaborCost":
    "• 人员成本：固定月薪 + 项目绩效（如适用）",
  "FinancialModel.monthlyAnalysis.metricProjectExpense":
    "• 项目支出：每个活跃项目预算2000元",
  "FinancialModel.monthlyAnalysis.metricExpenseEfficiency":
    "• 支出效率 = 项目完成率 / 总支出",
  "FinancialModel.costStructure.pieTitle": "支出构成分析（基于实际报销数据）",
  "FinancialModel.costStructure.detailTitle": "费用明细（基于实际报销数据）",
  "FinancialModel.costStructure.total": "总成本（报销累计）",
  "FinancialModel.costStructure.recordTitle": "详细报销记录",
  "FinancialModel.costStructure.table.category": "类别",
  "FinancialModel.costStructure.table.desc": "说明",
  "FinancialModel.costStructure.table.amount": "金额",
  "FinancialModel.costStructure.人力成本": "人力成本",
  "FinancialModel.costStructure.研发材料设备": "研发材料设备",
  "FinancialModel.costStructure.云服务软件": "云服务软件",
  "FinancialModel.costStructure.市场与销售": "市场与销售",
  "FinancialModel.costStructure.行政与合规": "行政与合规",
  "FinancialModel.costStructure.杂项预备金": "杂项预备金",
  "FinancialModel.expenseForecast.section1Title": "1. Runway变化趋势（月）",
  "FinancialModel.expenseForecast.methodTitle": "预测方法：",
  "FinancialModel.expenseForecast.methodFormula":
    "Runway = 当前现金余额 ÷ 月度总支出。",
  "FinancialModel.expenseForecast.baseCaseDesc": "：假设支出按当前趋势不变；",
  "FinancialModel.expenseForecast.bestCaseDesc": "：每季度支出下降5%；",
  "FinancialModel.expenseForecast.worstCaseDesc": "：每季度支出上升5%。",
  "FinancialModel.expenseForecast.section1Explain":
    "Runway（现金流可持续月数）表示企业在当前现金储备和支出速度下还能维持运营的月份数。该趋势图展示了在不同情景下（基准、乐观、保守）未来一年内的Runway变化，帮助管理层评估资金安全边际和决策空间。",
  "FinancialModel.expenseForecast.baseCase": "Base Case（基准）",
  "FinancialModel.expenseForecast.baseCaseExplain":
    "：假设收入和支出按当前趋势发展，Runway逐步缩短，需关注现金流健康。",
  "FinancialModel.expenseForecast.bestCase": "Best Case（乐观）",
  "FinancialModel.expenseForecast.bestCaseExplain":
    "：收入提升、成本优化，Runway延长，企业抗风险能力增强。",
  "FinancialModel.expenseForecast.worstCase": "Worst Case（保守）",
  "FinancialModel.expenseForecast.worstCaseExplain":
    "：收入停滞或成本上升，Runway大幅缩短，需提前预警并制定应对措施。",
  "FinancialModel.expenseForecast.scenarioForecastTitle":
    "情景预测 - Runway变化趋势（月）",
  "FinancialModel.expenseForecast.yAxisFormatter":
    "{{v}} 个月（可持续运营月数）",
  "FinancialModel.expenseForecast.healthyLabel": "健康：资金可支撑超过12个月",
  "FinancialModel.expenseForecast.alertLabel": "警告：资金可支撑小于6个月",
  "FinancialModel.expenseForecast.noticeLabel": "注意：资金可支撑6-12个月",
  "FinancialModel.expenseForecast.section2Title": "2. 驱动因素预测",
  "FinancialModel.expenseForecast.laborCost": "人力成本",
  "FinancialModel.expenseForecast.laborCostFormula": "员工人数 × 人均薪资",
  "FinancialModel.expenseForecast.laborCostCurrent":
    "当前：2人 × ¥10,000 = ¥20,000/月",
  "FinancialModel.expenseForecast.materialCost": "研发材料费",
  "FinancialModel.expenseForecast.materialCostFormula":
    "研发人数 × 平均材料成本",
  "FinancialModel.expenseForecast.materialCostCurrent":
    "当前：2人 × ¥3,000 = ¥6,000/月",
  "FinancialModel.expenseForecast.cloudCost": "云服务成本",
  "FinancialModel.expenseForecast.cloudCostFormula": "活跃用户 × 单用户成本",
  "FinancialModel.expenseForecast.cloudCostCurrent":
    "预计：100用户 × ¥30 = ¥3,000/月",
  "FinancialModel.expenseForecast.driverForecastTrend":
    "驱动因素预测 - 成本趋势",
  "FinancialModel.expenseForecast.section3Title": "3. 情景预测",
  "FinancialModel.expenseForecast.baseCaseSituation": "Base Case（基准情况）",
  "FinancialModel.expenseForecast.baseCaseIncome": "• 收入增长10%",
  "FinancialModel.expenseForecast.baseCaseMarket": "• 市场费用维持现状",
  "FinancialModel.expenseForecast.baseCaseRunway": '{">"} Runway: 18个月',
  "FinancialModel.expenseForecast.bestCaseSituation": "Best Case（乐观情况）",
  "FinancialModel.expenseForecast.bestCaseIncome": "• 收入增长20%",
  "FinancialModel.expenseForecast.bestCaseHardware":
    "• 批量化采购，硬件成本-10%",
  "FinancialModel.expenseForecast.bestCaseRunway": '{">"} Runway: 24个月',
  "FinancialModel.expenseForecast.worstCaseSituation": "Worst Case（保守情况）",
  "FinancialModel.expenseForecast.worstCaseIncome": "• 收入0增长",
  "FinancialModel.expenseForecast.worstCaseChip": "• 芯片价格+20%",
  "FinancialModel.expenseForecast.worstCaseRunway": '{">"} Runway: 12个月',
  "FinancialModel.expenseForecast.unitEconomicsTrend": "单位经济分析趋势",
  "FinancialModel.expenseForecast.section4Title": "4. 单位经济分析",
  "FinancialModel.expenseForecast.cac": "获客成本(CAC)",
  "FinancialModel.expenseForecast.cacFormula": "市场总费用 ÷ 新增用户数",
  "FinancialModel.expenseForecast.ltv": "生命周期价值(LTV)",
  "FinancialModel.expenseForecast.ltvFormula": "单台毛利 × 生命周期（月）",
  "FinancialModel.expenseForecast.unitEconomicsRatio": "单位经济比率",
  "FinancialModel.expenseForecast.unitEconomicsRatioExplain":
    'LTV/CAC {">"} 3 表示模式健康',
  "FinancialModel.expenseForecast.sensitivityAnalysisTitle":
    "敏感性分析 - 各项成本变化对Runway的影响（月）",
  "FinancialModel.loading": "加载中...",
  "FinancialModel.error": "错误",
  "FinancialModel.tab.monthlyAnalysis": "月度分析",
  "FinancialModel.tab.expenseForecast": "支出预测",
  "FinancialModel.tab.costStructure": "成本构成",
  "FinancialModel.tab.efficiencyAnalysis": "效率分析",
  "FinancialModel.pageTitle": "LUKKEY 项目分析",
  "FinancialModel.fundStatusAnalysis": "资金状况分析",
  "FinancialModel.status.warning": "需要注意",
  "FinancialModel.status.healthy": "状态健康",
  "FinancialModel.status.notice": "注意",
  "FinancialModel.status.alert": "警告",
  "FinancialModel.fundSupportDuration": "资金可支撑时间",
  "FinancialModel.month": "个月",
  "FinancialModel.warningLine": "警戒线",
  "FinancialModel.avgMonthlyExpense": "月均支出",
  "FinancialModel.basedOnLast3Months": "基于最近3个月平均",
  "FinancialModel.remainingFunds": "剩余资金",
  "FinancialModel.initialFunds": "初始资金",
  "FinancialModel.currency.chf": "瑞郎",
  "FinancialModel.fundSupportOver12Months": "资金可支撑超过12个月",
  "FinancialModel.fundSupport6to12Months": "资金可支撑 6-12个月",
  "FinancialModel.fundSupportLess6Months": "资金可支撑小于6个月",
  "FinancialModel.avgMonthlyExpenseCalc": "月均支出计算",
  "FinancialModel.considerExpenseTrend": "考虑支出增长趋势进行预测",
  "FinancialModel.forecastLimit": "预测期限上限",
  "FinancialModel.dataUpdateTime": "数据更新时间",
  // ===== MarketView i18n =====
  // ===== MarketView i18n =====
  "MarketView.title": "市场看板",
  "MarketView.loading": "加载中...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X（推特）",
  "MarketView.tabError.failed": "该标签页渲染失败",
  "MarketView.unknownError": "未知错误",
  // ===== Common i18n =====
  "Common.refresh": "刷新",
  "Common.toggleSeriesVisibility": "点击显示/隐藏该曲线",
  "Common.error": "错误",
  "Common.dataUpdateTime": "数据更新时间",
  "Common.loading": "加载中...",
  "Common.noDataSource": "暂无数据（数据源未提供）",
  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "下载后端 data/youtube_stats.json",
  "YouTubeTab.downloadJson": "下载 youtube_stats.json",
  "YouTubeTab.loading": "正在加载 YouTube 指标...",
  "YouTubeTab.errorHint":
    "若提示未配置 API Key，请在 backend/.env 设置 YOUTUBE_API_KEY 或 GOOGLE_API_KEY 并重启后端。",
  "YouTubeTab.header.totalViews": "总播放量（多渠道对比，单位：万）",
  "YouTubeTab.header.totalSubscribers": "总粉丝数（多渠道对比，单位：万）",
  "YouTubeTab.dist.views": "播放量分布（万）",
  "YouTubeTab.dist.subscribers": "粉丝数分布（万）",
  "YouTubeTab.card.location": "归属地：",
  "YouTubeTab.card.registeredAt": "注册时间：",
  "YouTubeTab.card.currentSubscribers": "当前粉丝数",
  "YouTubeTab.card.currentVideos": "当前视频数",
  "YouTubeTab.card.currentTotalViews": "当前总播放量",
  "YouTubeTab.card.currentTotalComments": "当前总评论数",
  "YouTubeTab.chart.totalSubscribers": "总粉丝数",
  "YouTubeTab.chart.totalViews": "总播放量",
  "YouTubeTab.chart.totalComments": "总评论数",
  "YouTubeTab.chart.totalVideos": "总视频数",
  // ===== XTab i18n =====
  "XTab.downloadTitle": "下载后端 data/x_stats.json",
  "XTab.downloadJson": "下载 x_stats.json",
  "XTab.loading": "正在加载 X 指标...",
  "XTab.errorHint":
    "若提示未配置 Token，请在 backend/.env 设置 X_BEARER_TOKEN 或 TWITTER_BEARER_TOKEN 并重启后端。",
  "XTab.header.totalFollowers": "总粉丝数（多渠道对比，单位：万）",
  "XTab.header.totalEngagement":
    "总互动量（最近5条：点赞+转推+回复+引用，单位：万）",
  "XTab.dist.followers": "粉丝数分布（万）",
  "XTab.dist.engagement":
    "互动量分布（最近5条：点赞+转推+回复+引用，单位：万）",
  "XTab.card.currentFollowers": "当前粉丝数",
  "XTab.card.currentFollowing": "当前关注数",
  "XTab.card.currentTweets": "当前推文数",
  "XTab.card.recentLikes": "最近推文点赞总数",
  "XTab.card.recentRetweets": "最近推文转推总数",
  "XTab.card.recentReplies": "最近推文回复总数",
  "XTab.card.recentQuotes": "最近推文浏览总数(内容级)",
  "XTab.card.listed": "被列入列表数(频道级)",
  "XTab.smallChart.followers": "粉丝数",
  "XTab.smallChart.tweets": "推文数",
  "XTab.smallChart.likes": "最近推文点赞总数",
  "XTab.smallChart.retweets": "最近推文转推总数",
  "XTab.smallChart.replies": "最近推文回复总数",
  "XTab.smallChart.quotes": "最近推文浏览总数(内容级)",
  "XTab.smallChart.following": "关注数",
  "XTab.smallChart.listed": "被列入列表数(频道级)",
  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "筛选任务创建月份：",
  "Analytics.metric.completionRate": "完成率",
  "Analytics.metric.teamVelocity": "团队速度",
  "Analytics.metric.blockerRatio": "阻塞率",
  "Analytics.metric.workloadBalance": "负载均衡",
  "Analytics.charts.statusDistribution": "📊 状态分布",
  "Analytics.charts.statusByMonthPercent": "📅 状态按月百分比分布",
  "Analytics.charts.priorityDistribution": "🎯 优先级分布",
  "Analytics.charts.priorityByMonthPercent": "📅 优先级按月百分比分布",
  "Analytics.charts.functionTypeDistribution": "🧩 职能类型分布",
  "Analytics.charts.functionTypeByMonthPercent": "📅 职能类型按月百分比分布",
  "Analytics.blocker.ownerPie": "🚫 阻塞问题 · 责任人分布（环形）",
  "Analytics.blocker.ownerByMonth": "📅 阻塞问题 · 责任人按月百分比分布",
  "Analytics.bug.ownerPie": "🐞 缺陷问题 · 责任人分布（环形）",
  "Analytics.bug.ownerByMonth": "📅 缺陷问题 · 责任人按月百分比分布",
  "Analytics.charts.ownerByMonthCount": "📅 责任人按月数量分布（堆叠）",
  "Analytics.ownerWorkloadDistribution": "⚡ 团队工作量分布",
  "Analytics.select.owners": "负责人选择：",
  "Analytics.mode.priority": "优先级分布",
  "Analytics.mode.status": "状态分布",
  "Analytics.mode.type": "任务类型分布",
  "Analytics.blocker.attentionNeeded": "需要立即关注的问题",
  "Analytics.common.status": "状态",
  "Analytics.common.owner": "责任人",
  "Analytics.insights.sectionTitle": "项目洞察和建议",
  "Analytics.insights.efficiency.title": "效率提升建议",
  "Analytics.insights.efficiency.completionRate":
    "• 当前完成率为 {{rate}}%，建议关注阻塞问题",
  "Analytics.insights.efficiency.avgVelocity":
    "• 团队平均速度为 {{velocity}} 个任务/人",
  "Analytics.insights.efficiency.workloadBalance":
    "• 工作负载均衡度为 {{balance}}%",
  "Analytics.insights.risk.title": "风险预警",
  "Analytics.insights.risk.blockerRatio": "• 阻塞问题占比 {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 级别问题占比 {{ratio}}%",
  "Analytics.insights.risk.suggestion": "• 建议优先处理高优先级问题",
  // ===== Common ranges =====
  "Common.to": "至",
  "Common.clear": "清除",
  "Common.range.thisMonth": "本月",
  "Common.range.lastMonth": "上月",
  "Common.range.last2": "近2个月",
  "Common.range.last3": "近3个月",
  "Common.range.last6": "近6个月",
  "Common.range.thisYear": "今年",
  "Common.range.all": "全部",
  "Common.range.custom": "自定义",
  // ===== Common UI (extra) =====
  "Common.showFilters": "显示筛选器",
  "Common.hideFilters": "隐藏筛选器",
  "Common.search": "搜索",
  "Common.priority": "优先级",
  "Common.owner": "责任人",
  "Common.collaborator": "协作者",
  "Common.updatedAt": "更新",
  // ===== Kanban i18n =====
  "Kanban.title": "看板视图",
  "Kanban.totalIssues": "共 {{count}} 个问题",
  "Kanban.searchPlaceholder": "搜索标题、问题编号、责任人或协作者...",
  "Kanban.status.backlog": "待处理",
  "Kanban.status.inProgress": "进行中",
  "Kanban.status.blocked": "阻塞/待确认",
  "Kanban.status.reviewTest": "评审 / 测试",
  "Kanban.status.docs": "Docs",
  // ===== List i18n =====
  "List.title": "议题列表",
  "List.totalIssues": "共 {{count}} 个问题",
  "List.viewDetails": "查看详情",
  "List.openInNewWindow": "在新窗口打开",
  "List.empty.title": "暂无问题",
  "List.empty.subtitle": "创建第一个问题来开始你的工作流",
  // ===== Assets Register i18n =====
  "Assets.title": "资产设备登记表",
  "Assets.totalSets": "合计套数",
  "Assets.table.employee": "员工",
  "Assets.table.setCount": "套数",
  "Assets.table.model": "型号",
  "Assets.total": "合计",
  "Assets.table.screen": "屏幕",
  // ===== Production Assets i18n =====
  "Assets.production.title": "量产设备登记表",
  "Assets.production.totalUnits": "量产合计台数",
  "Assets.production.table.sn": "设备编号",
  "Assets.production.table.owner": "持有人/去向",
  "Assets.production.table.status": "状态",
  "Assets.production.table.note": "备注",
  "Assets.production.total": "合计",
  "Assets.people.screenIcVendor": "屏幕IC厂",
  "Assets.people.stVendor": "ST原厂",
  "Assets.models.gen3EalPcb": "3代EAL版pcb",
  "Assets.models.gen3Pcb": "3代pcb",
  "Assets.models.gen3PcbDamagedBluetooth":
    "❌3代pcb已损坏(PCB蓝牙无法烧录)",
  "Assets.models.gen3AssembledBlackUnit": "3代整机组装版pcb(黑色整机)",
  "Assets.models.gen3PcbDamagedSerial": "❌3代pcb(串口损坏)",
  "Assets.production.models.black": "黑色",
  "Assets.production.models.silver": "银色",
  "Assets.production.models.champagneGold": "香槟金",
  "Assets.production.models.blackKeystonePrototype": "黑色（keystone样机）",
  "Assets.production.models.blackHardwareUnoptimized": "黑色(硬件未优化)",
  "Assets.production.models.shellless": "无壳",
  "Assets.production.models.shelllessBroken": "无壳（坏掉）",
  "Assets.production.models.silverHeldByLijiaqi": "银色（李佳奇代持）",
  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "项目议题跟踪",
  "LukkeyIssues.goToDemo": "前往演示Demo页面",
  "LukkeyIssues.githubProject": "GitHub Project ↗",
  "LukkeyIssues.githubManageIssues": "在 GitHub 直接管理 Issues ↗",
  "LukkeyIssues.financeModel": "Finance 模型",
  "LukkeyIssues.productCoreIssues": "产品本体议题",
  "LukkeyIssues.stats.totalIssues": "📊 议题总数",
  "LukkeyIssues.stats.completed": "✅ 已完成",
  "LukkeyIssues.stats.inProgress": "🔄 进行中",
  "LukkeyIssues.stats.pending": "⏳ 待处理",
  "LukkeyIssues.stats.blocked": "🚫 阻塞",
  "LukkeyIssues.stats.docs": "📚 文档 Docs",
  "LukkeyIssues.tabs.kanban": "看板视图",
  "LukkeyIssues.tabs.analytics": "数据分析",
  "LukkeyIssues.tabs.market": "市场看板",
  "LukkeyIssues.tabs.assets": "资产设备登记表",
  "LukkeyIssues.shareToChatGPT": "用 ChatGPT 打开 LUKKEY.json",
  // ===== 其它原有翻译 =====
  Product: "产品",
  "Header.productNav": "LUKKEY 产品",
  Feature: "功能",
  "About Us": "关于我们",
  FAQ: "常见问题",
  "Privacy Policy": "隐私政策",
  "Help Center": "帮助中心",
  "Header.infoMenu": "更多",
  "Header.appNow": "获取 App",
  "Header.appModal.title": "立即使用 LUKKEY App",
  "Header.appModal.subtitle": "选择你的平台，获取官方 LUKKEY 移动应用。",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "在 iPhone 上安装官方应用。",
  "Header.appModal.iosButton": "打开",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "前往 Google Play 获取官方 Android 应用。",
  "Header.appModal.googlePlayButton": "打开",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "直接下载最新版官方 APK。",
  "Header.appModal.androidButton": "下载",
  "Header.appModal.note": "仅提供官方移动端下载，请使用以上链接获取最新版本。",
  "Academy": "学院",
  "Legal": "法律",
  "AboutUs.title": "关于 LUKKEY",
  "AboutUs.lede": "LUKKEY 是一家瑞士硬件钱包品牌，致力于打造数字资产所有权的最高安全标准。",
  "AboutUs.vision.closing": "你的密钥。你的资产。你的未来。",
  "AboutUs.quote": "LUKKEY 在人与数字资产之间建立一层安全边界。",
  "AboutUs.block1": "LUKKEY 总部位于瑞士，专注于面向安全自托管场景的硬件钱包产品。",
  "AboutUs.block2": "其产品结合安全元件、防篡改保护和全离线架构，目标是让私钥始终保留在隔离环境中。",
  "AboutUs.block3": "系统不依赖 Wi‑Fi、USB 或直接联网。指纹解锁、NFC 备份工具和广泛的资产支持，让产品在日常使用中保持实用。",
  "AboutUs.block5": "LUKKEY 对核心固件和软件采用开放且可审计的方式。安全能力应当可被检查，也可被验证。",
  "HelpCenter.back": "返回帮助中心",
  "WarrantySupport.title": "支持请求",
  "WarrantySupport.intro": "请填写以下信息以提交支持请求。",
  "WarrantySupport.form.name.label": "姓名",
  "WarrantySupport.form.name.placeholder": "请输入姓名",
  "WarrantySupport.form.email.label": "邮箱",
  "WarrantySupport.form.email.placeholder": "请输入邮箱",
  "WarrantySupport.form.issueTitle.label": "问题概述",
  "WarrantySupport.form.issueTitle.placeholder": "请输入简要概述",
  "WarrantySupport.form.warrantyType.label": "请求类型",
  "WarrantySupport.form.warrantyType.placeholder": "请选择请求类型",
  "WarrantySupport.form.warrantyType.product": "设备问题",
  "WarrantySupport.form.warrantyType.service": "App/账户问题",
  "WarrantySupport.form.warrantyType.replacement": "其他",
  "WarrantySupport.form.feedback.label": "问题描述",
  "WarrantySupport.form.feedback.placeholder": "请详细描述问题或需求",
  "WarrantySupport.form.submit": "提交支持请求",
  "WarrantySupport.alert.success": "您的支持请求已提交！",
  "WarrantySupport.alert.error": "提交失败，请稍后再试。",
  "HelpCenter.title": "帮助中心",
  "HelpCenter.intro":
    "欢迎来到 LUKKEY 官方帮助中心与文档支持。这里提供硬件钱包产品指南、设置说明与故障排查资料。",
  "HelpCenter.section4.title": "需要更多帮助？",
  "HelpCenter.section4.intro":
    "在线提交支持请求可节省时间，我们将安排专人协助。为保护安全，官方支持绝不会索要助记词或私钥：",
  "HelpCenter.contact.hint": "可通过下方按钮提交支持请求，我们将通过邮箱与您联系。",
  "HelpCenter.cta.warranty": "提交支持请求",
  "Footer.contact.email": "邮箱：info@lukkey.com",
  "Footer.contact.address":
    "Lukkey AG 全球总部，瑞士 Zug，Dammstrasse 16，邮编 6300",
  brandName: "LUKKEY",
  tagline: "让安全自托管，变得更简单。",
  description:
    "LUKKEY 以硬件级防护让私钥始终离线，帮助你用更可控、更低风险的方式存储和管理加密资产。",  learnMore: "了解更多",
  "Lock Your Crypto, Securely": "安全地锁定您的加密货币",
  Testimonials: "用户评价",
  Testimonial1:
    "我已经使用这个冷钱包好几个月了，印象深刻的是它的可靠性和安全功能。强烈推荐！",
  Testimonial2:
    "这个冷钱包超出了我的预期！它的用户友好界面和一流的安全性让它成为任何严肃的加密货币用户必备的工具。",
  Testimonial3:
    "我之前试过几个冷钱包，但这个脱颖而出。它的流线型设计和先进功能让管理我的加密资产变得轻松。",
  "John Doe": "约翰·多伊",
  "Cryptocurrency Enthusiast": "加密货币爱好者",
  "Jane Smith": "简·史密斯",
  "Crypto Security Advocate": "加密安全倡导者",
  "Alex Johnson": "亚历克斯·约翰逊",
  "Investment Analyst": "投资分析师",
  "Touchscreen Interface": "触摸屏界面",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "通过我们直观的触摸屏界面，轻松管理您的加密资产，界面设计简洁，能够快速、便捷地浏览您的数字资产，实现快速交易和安全管理。",
  "Bluetooth Connectivity": "蓝牙连接",
  "Wireless syncing with your devices for real-time updates.":
    "与您的设备无线同步，实时更新。",
  "Airtag Tracking": "Airtag 跟踪",
  "Track your wallet easily with built-in Airtag.":
    "通过内置的 Airtag，轻松追踪您的钱包。",
  "home.secureChip.title": "EAL6+ 安全芯片技术",
  "home.secureChip.description":
    "配备 EAL6+ 安全芯片，为您的宝贵数字资产提供强大保护，有效防止未经授权的访问与网络威胁。",
  "home.multiAccount.title": "一台 Lukkey，3 个钱包",
  "home.multiAccount.description": "一台设备内支持 3 个独立钱包，各自拥有单独的助记词。",
  "Secure Chip Technology": "安全芯片技术",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "配备先进的安全芯片，确保您的宝贵数字资产免受未经授权的访问和网络威胁，提供强大的保护。",
  "Cross-Platform Support": "跨平台支持",
  "Works with various platforms for easy accessibility.":
    "与多种平台兼容，轻松访问。",
  AboutUsDescription1:
    "在LUKKEY，我们致力于提供高质量的解决方案，安全地管理您的加密资产。",
  AboutUsDescription2:
    "我们的总部位于瑞士楚格。凭借一支经验丰富的团队，我们努力创新并适应数字货币市场不断变化的格局。",
  BlockchainNetworksSupported: "支持的区块链网络",
  CryptocurrenciesSupported: "支持超过6,000种加密货币",
  "home.warranty.years": "年",
  "home.warranty.label": "质保",
  Years: "年",
  ExpertiseInSecurity: "在安全领域的专业经验",
  FrequentlyAskedQuestions: "常见问题",
  WhatIsColdWallet: "什么是冷钱包？",
  ColdWalletDescription:
    "冷钱包是一种加密货币钱包，它将您的数字资产离线存储，从而使其不容易受到黑客攻击和其他在线威胁。与在线连接且适合频繁交易的热钱包不同，冷钱包最适合长期存储，因为它们提供增强的安全性。",
  HowToSetUpColdWallet: "如何设置冷钱包？",
  ColdWalletSetupDescription:
    "设置冷钱包通常涉及在安全的离线机器上初始化设备。您需要生成并安全地存储恢复短语，这对于在设备丢失或故障时访问您的资产至关重要。购买时会提供详细的说明，确保顺利完成设置过程。",
  CryptocurrenciesCompatibleWithColdWallet: "哪些加密货币可以与冷钱包兼容？",
  CryptocurrenciesCompatibilityDescription:
    "我们的冷钱包支持多种加密货币，包括比特币、以太坊、莱特币等主要货币，以及各种其他山寨币。有关支持的完整货币列表，请访问我们的网站或参考产品文档。",
  HowToSecureColdWallet: "如何确保冷钱包安全？",
  ColdWalletSecurityDescription:
    "为了确保冷钱包的安全，始终将恢复短语保存在安全和私密的位置，切勿与任何人分享，并考虑使用额外的安全措施，例如生物识别锁或安全外壳。定期从官方网站更新钱包的固件也有助于防范漏洞。",
  ColdWalletNotWorking: "如果我的冷钱包无法正常工作或遇到错误该怎么办？",
  ColdWalletErrorDescription:
    "如果您的冷钱包出现问题，请参考我们的用户指南中的故障排除部分。对于更具体的问题，请通过我们的网站联系支持团队。确保提供设备信息以加快支持过程。",
  Community: "社区",

  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "加入我们的社区，在你喜爱的平台上保持最新状态，提出问题，并与其他用户建立联系。",

  // Newsletter subscribe
  "Subscribe.title": "获取产品更新",
  "Subscribe.subtitle":
    "加密趋势由我们替你追踪。获取产品更新、市场洞察与专属福利——第一时间直达你的收件箱。",
  "Subscribe.placeholder": "输入你的邮箱",
  "Subscribe.button": "订阅产品更新",
  "Subscribe.input.aria": "邮箱地址输入框",
  "Subscribe.success": "订阅成功！请前往邮箱查收确认邮件。",
  "Subscribe.error": "订阅失败，请稍后重试。",
  "Subscribe.invalid": "请输入有效的邮箱地址。",
  "Subscribe.privacy":
    "你的邮箱仅用于接收我们的新闻通讯与更新。你可随时通过邮件中的链接取消订阅。",
  "Subscribe.learnMore": "了解我们如何管理你的数据与权利。",
  "Subscribe.popupCompact.title": "保持更新",
  "Subscribe.popupCompact.subtitle": "产品更新与安全洞察。不发送垃圾邮件。",
  "Subscribe.popupCompact.button": "订阅",
  "Subscribe.popupCompact.privacy": "仅用于邮件通知。可随时退订。",
  "SubscribeConfirmed.alt.success": "订阅已确认",
  "SubscribeConfirmed.alt.failed": "订阅确认失败",
  "SubscribeConfirmed.title.success": "订阅已确认",
  "SubscribeConfirmed.title.failed": "订阅失败",
  "SubscribeConfirmed.message.success":
    "感谢你确认邮箱。你的订阅已激活。欢迎邮件已发送至你的收件箱。",
  "SubscribeConfirmed.message.failed":
    "确认链接无效或已过期。请返回首页并重新尝试订阅。",
  "SubscribeConfirmed.cta.backHome": "返回首页",
  "SubscribeConfirmed.note.unsubscribe": "你可以随时通过邮件中的链接取消订阅。",
  // Lukkey page
  "lukkey.hero.title": "LUKKEY",
  "lukkey.hero.subtitle": "Your assets your control",
  "lukkey.hero.imageAlt": "Lukkey 冷钱包主视觉产品图",
  "lukkey.physical.title": "安全，生于硅芯。",
  "lukkey.physical.subtitle":
    "由多个安全元件构建的硬件安全架构，以 EAL6+ 级信任根为锚点，并通过防篡改电路与结构设计进一步加固。",
  "lukkey.physical.annotation.title": "硬件级信任根。",
  "lukkey.physical.annotation.description":
    "由多个安全元件构建，以 EAL6+ 为锚点，并通过防篡改电路与结构设计进一步加固。",
  "lukkey.physical.cardTamper.title": "PCI 级防拆（灌胶 + 自毁）",
  "lukkey.physical.cardTamper.description":
    "设备爆炸结构图，灌胶层半透明包裹核心芯片，层级清晰但不可触达。",
  "lukkey.physical.cardChip.title": "EAL6+ 安全芯片",
  "lukkey.physical.cardChip.description":
    "芯片独立悬浮于黑色空间，数据光线被安全边界限制。",
  "lukkey.physical.explode.coreChip": "核心芯片",
  "lukkey.physical.explode.securityBoundary": "安全边界",
  "lukkey.physical.explode.pottingLayer": "灌胶层",
  "lukkey.physical.explode.outerShell": "外壳",
  "lukkey.design.title": "设计不是装饰，而是可信度",
  "lukkey.design.description":
    "工业设计 + iF / 红点奖级别质感，材质特写强调边框倒角与玻璃微反射。",
  "lukkey.design.featureTitle": "彩色触控屏 · 银行卡尺寸",
  "lukkey.design.featureDescription":
    "与真实银行卡 1:1 对比，强调厚度 9.6mm 的随身携带感。",
  "lukkey.design.thickness": "厚度 9.6mm",
  "lukkey.design.closing": "微距切换与高光扫过，回到整体形态依旧精致。",
  "lukkey.reliability.title": "IP68 防水\nIP6X 防尘",
  "lukkey.reliability.description": "支持 IP68 级防水与 IP6X 级防尘，在严苛环境中依然有效阻隔进水与粉尘侵入。",
  "lukkey.reliability.canvasLine1": "IP68 防水",
  "lukkey.reliability.canvasLine2": "IP6X 防尘",
  "lukkey.reliability.bullet1": "水体慢动作包裹设备",
  "lukkey.reliability.bullet2": "高速水珠击打但无侵入",
  "lukkey.reliability.bullet3": "防尘、防水、防跌落",
  "lukkey.reliability.imageAlt": "Lukkey IP68 防水展示图",
  "lukkey.system.title": "Safe Mode",
  "lukkey.system.description":
    "A discreet protection layer for sensitive situations.\n\nSafenotes disguises the wallet interface as a notes-style page,\nwhile only the active account remains visible.\nSensitive operations such as single-account deletion are restricted.",
  "lukkey.system.account.accountA": "账户 A",
  "lukkey.system.account.hiddenWallet": "隐藏钱包",
  "lukkey.system.account.decoyVault": "诱饵钱包",
  "lukkey.system.account.locked": "已锁定",
  "lukkey.system.multiAccountTitle": "支持 3 套助记词",
  "lukkey.system.multiAccountDescription": "支持 3 套助记词，对应三套完全独立的钱包体系。",
  "lukkey.system.layers.primary": "主账户",
  "lukkey.system.layers.vault": "金库层",
  "lukkey.system.layers.shadow": "影子层",
  "lukkey.daily.title": "指纹解锁",
  "lukkey.daily.description":
    "Unlock your wallet instantly with fingerprint authentication.\n\nFast, seamless, and verified directly on the device.",
  "lukkey.capability.title": "支持 NFT",
  "lukkey.capability.description":
    "暗色空间的资产陈列舱，卡片玻璃化、低饱和、强调收藏与掌控。",
  "lukkey.capability.nftItem": "NFT #{{index}}",
  "lukkey.backup.title": "NFC 助记词备份",
  "lukkey.backup.description": "冷钱包靠近 NFC 卡 / 戒指，波纹状 NFC 信号同步。",
  "lukkey.backup.imageAlt": "NFC 助记词备份演示",
  "lukkey.trust.title": "Open & Verifiable Security",
  "lukkey.trust.description":
    "Built on an EAL6+ secure element and an open-source architecture,\nLUKKEY allows both hardware and software security to be independently verified.\n\nKey generation, storage, and signing remain protected inside the device,\nwhile open-source code enables transparent security review by the community.\n\nSecurity you can verify. Control that remains yours.",
  "lukkey.video.title": "为保护而生，为长期而设计。",
  "lukkey.video.description":
    "源自瑞士工艺，偏执追求安全。LUKKEY 为追求绝对掌控的人而生。",
  "lukkey.values.privacy.title": "隐私",
  "lukkey.values.privacy.description":
    "私钥永不离开设备。离线签名让关键操作始终在本地完成。",
  "lukkey.values.inclusive.title": "包容性设计",
  "lukkey.values.inclusive.description":
    "以人为中心的交互设计，新手易上手，专业用户也能高效完成操作。",
  "lukkey.values.secure.title": "安全",
  "lukkey.values.secure.description":
    "硬件级安全架构叠加多层防护，抵御篡改、提取与伪造风险。",
  "lukkey.values.environment.title": "环境",
  "lukkey.values.environment.description":
    "以长期使用为目标，采用耐用材质与可维护结构，减少频繁更换带来的浪费。",
  "lukkey.contact.title": "保持联系",
  "lukkey.contact.announcements": "最新公告可在我们的博客中查看。",
  "lukkey.contact.pressLabel": "媒体联系：",
  "lukkey.modal.contentLabel": "邮箱确认弹窗",
  "lukkey.modal.title": "确认你的邮箱",
  "lukkey.modal.description1":
    "请打开发送给你的确认邮件并点击验证链接。也请检查垃圾邮箱。",
  "lukkey.modal.description2": "你可以随时取消订阅。",
  "lukkey.modal.close": "关闭",

  // ===== Common =====
  "Common.language": "语言",

  // ===== PasswordProtectedRoute =====
  "PasswordProtected.title": "请输入密码以访问此页面。",
  "PasswordProtected.placeholder": "密码",
  "PasswordProtected.signIn": "登录",
  "PasswordProtected.error": "密码不正确，请重试。",
  "PasswordProtected.show": "显示密码",
  "PasswordProtected.hide": "隐藏密码",

  // ===== AdminAuth (/admin/auth) =====
  "AdminAuth.checking": "检查会话中…",
  "AdminAuth.header.title": "认证管理面板",
  "AdminAuth.header.downloadUsers": "下载用户目录 JSON",
  "AdminAuth.header.downloadWhitelist": "下载白名单 JSON",
  "AdminAuth.header.logout": "退出",
  "AdminAuth.users.title": "用户目录",
  "AdminAuth.whitelist.title": "白名单",
  "AdminAuth.common.refresh": "刷新",
  "AdminAuth.loading": "加载中…",
  "AdminAuth.error.loadUsers": "加载用户目录失败",
  "AdminAuth.error.loadWhitelist": "加载白名单失败",
  "AdminAuth.error.notSuperadmin":
    "需要超级管理员白名单权限，请使用超级管理员邮箱登录。",
  "AdminAuth.table.email": "邮箱",
  "AdminAuth.table.name": "姓名",
  "AdminAuth.table.firstSeen": "首次记录",
  "AdminAuth.table.lastLogin": "最近登录",
  "AdminAuth.table.loginCount": "登录次数",
  "AdminAuth.table.addedAt": "添加时间",
  "AdminAuth.table.level": "等级",
  "AdminAuth.table.actions": "操作",
  "AdminAuth.noData": "暂无数据",
  "AdminAuth.users.quickAdd": "加入白名单",
  "AdminAuth.users.quickAddBlacklist": "加入黑名单",
  "AdminAuth.whitelist.add.placeholderEmail": "邮箱",
  "AdminAuth.whitelist.add.placeholderName": "姓名（可选）",
  "AdminAuth.whitelist.add.submit": "添加白名单",
  "AdminAuth.whitelist.add.success": "已添加到白名单",
  "AdminAuth.whitelist.level.normal": "普通白名单",
  "AdminAuth.whitelist.level.developer": "开发者",
  "AdminAuth.whitelist.level.publisher": "发布管理员",
  "AdminAuth.whitelist.level.superadmin": "超级管理员",
  "AdminAuth.whitelist.remove": "移除",
  "AdminAuth.whitelist.remove.success": "已从白名单移除",
  "AdminAuth.whitelist.empty": "白名单为空",

  "AdminAuth.error.loadBlacklist": "加载黑名单失败",
  "AdminAuth.header.downloadBlacklist": "下载黑名单 JSON",
  "AdminAuth.table.note": "备注",
  "AdminAuth.blacklist.title": "黑名单",
  "AdminAuth.blacklist.add.placeholderEmail": "邮箱",
  "AdminAuth.blacklist.add.placeholderNote": "备注（可选）",
  "AdminAuth.blacklist.add.submit": "加入黑名单",
  "AdminAuth.blacklist.add.success": "已加入黑名单",
  "AdminAuth.blacklist.remove": "移除",
  "AdminAuth.blacklist.remove.success": "已从黑名单移除",
  "AdminAuth.blacklist.empty": "黑名单为空",

  "AdminAuth.message.addFailed": "添加白名单失败",
  "AdminAuth.message.removeFailed": "移除白名单失败",
  "PrivacyPolicy.intro.p1":
    "在 LUKKEY，我们相信最安全的隐私，是始终掌握在用户自己手中的隐私。",
  "PrivacyPolicy.intro.p2":
    "因此，无论您使用的是 LUKKEY 硬件冷钱包，还是配套的 LUKKEY 手机应用（App），我们始终恪守一条不变的原则：",
  "PrivacyPolicy.intro.p3_strong":
    "除非用户明确授权，我们不收集、不存储、更不会上传任何用户信息。",
  "PrivacyPolicy.intro.p3_tail":
    "所有与使用相关的数据仅存储在用户本地设备中，绝不会传输至 LUKKEY 或任何服务器。",
  "PrivacyPolicy.intro.p4": "本隐私政策解释我们如何践行这一原则。",

  "PrivacyPolicy.s1.title": "1. 适用范围",
  "PrivacyPolicy.s1.appliesTo": "本隐私政策适用于：",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY 硬件冷钱包",
  "PrivacyPolicy.s1.item.app": "LUKKEY 手机应用（App）",
  "PrivacyPolicy.s1.principle":
    "二者均遵循“零收集、零上传、仅本地存储”的统一隐私原则。",

  "PrivacyPolicy.s2.title": "2. 我们不收集的信息",
  "PrivacyPolicy.s2.desc":
    "为保护您的隐私，我们明确承诺不收集、不上传、不存储任何用户信息，包括但不限于：",
  "PrivacyPolicy.s2.li.identity": "身份信息：姓名、手机号、邮箱、邮寄地址",
  "PrivacyPolicy.s2.li.walletSensitive":
    "钱包敏感数据：私钥、助记词、keystore 文件、钱包密码",
  "PrivacyPolicy.s2.li.blockchain": "区块链数据：钱包地址、交易记录、资产信息",
  "PrivacyPolicy.s2.li.behavior": "使用行为：应用日志、点击记录、行为分析",
  "PrivacyPolicy.s2.li.technical": "技术信息：设备标识符、地理位置、IP 地址",
  "PrivacyPolicy.s2.inShort.title": "简而言之：",
  "PrivacyPolicy.s2.inShort.desc":
    "硬件设备和 App 中您所看到的一切仅存在于您的设备上，LUKKEY 无法访问。",

  "PrivacyPolicy.s3.title": "3. 硬件冷钱包的隐私与安全设计",
  "PrivacyPolicy.s3.desc":
    "LUKKEY 冷钱包为用户提供完全离线、可验证的安全环境。核心特性包括：",
  "PrivacyPolicy.s3.h1.title": "1. 军工级安全硬件",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ 认证安全芯片（Secure Element）",
  "PrivacyPolicy.s3.h1.l2": "全链路硬件级加密通信",
  "PrivacyPolicy.s3.h2.title": "2. 安全功能",
  "PrivacyPolicy.s3.h2.l1": "指纹认证",
  "PrivacyPolicy.s3.h2.l2": "隐私模式",
  "PrivacyPolicy.s3.h2.l3": "多钱包隔离管理",
  "PrivacyPolicy.s3.h3.title": "3. 完全隔离",
  "PrivacyPolicy.s3.h3.l1": "无网络连接",
  "PrivacyPolicy.s3.h3.l2": "无数据线连接",
  "PrivacyPolicy.s3.h4.title": "4. 防拆自毁",
  "PrivacyPolicy.s3.h4.desc":
    "当设备被拆解、损坏或遭受异常入侵时，安全芯片将自动销毁敏感数据，确保私钥无法被提取。",
  "PrivacyPolicy.s3.h5.title": "5. 敏感操作仅在安全芯片内执行",
  "PrivacyPolicy.s3.h5.l1": "创建钱包",
  "PrivacyPolicy.s3.h5.l2": "导入钱包",
  "PrivacyPolicy.s3.h5.l3": "交易签名",
  "PrivacyPolicy.s3.h5.note":
    "所有敏感流程 100% 在安全芯片内完成，从不暴露给任何非安全芯片或存储区域。",
  "PrivacyPolicy.s3.h6.title": "6. 非安全区域不存放敏感数据",
  "PrivacyPolicy.s3.h6.desc":
    "设备的非安全存储区域不会存放私钥、助记词或任何敏感信息。",

  "PrivacyPolicy.s4.title": "4. LUKKEY App 的隐私与安全设计",
  "PrivacyPolicy.s4.desc":
    "LUKKEY App 仅用于展示信息与提供通知，不处理任何钱包敏感数据。",
  "PrivacyPolicy.s4.n1.title": "1. App 不做的事情",
  "PrivacyPolicy.s4.n1.l1": "不生成区块链钱包",
  "PrivacyPolicy.s4.n1.l2": "不导入区块链钱包",
  "PrivacyPolicy.s4.n1.l3": "不存储私钥或助记词",
  "PrivacyPolicy.s4.n1.l4": "不上传任何用户数据",
  "PrivacyPolicy.s4.n1.l5": "不进行行为分析、广告跟踪或数据采集",
  "PrivacyPolicy.s4.n2.title": "2. App 会做的事情",
  "PrivacyPolicy.s4.n2.l1": "展示由硬件授权的公开可见信息",
  "PrivacyPolicy.s4.n2.l2": "提供隐私设置面板，说明每项权限的用途",
  "PrivacyPolicy.s4.n2.l3": "赋予用户对各项权限的完全控制，随时启用/禁用",
  "PrivacyPolicy.s4.n2.l4": "提供敏感信息遮罩",
  "PrivacyPolicy.s4.n2.l5": "在特定页面禁用截屏/录屏",
  "PrivacyPolicy.s4.n2.l6": "通过本地匹配检测可疑区块链地址",
  "PrivacyPolicy.s4.n2.l7": "定期更新危险网址、合约与地址列表",
  "PrivacyPolicy.s4.n2.l8": "更新流程单向：仅从服务器 → 设备",
  "PrivacyPolicy.s4.n2.l9": "更新过程中从不回传任何用户数据",
  "PrivacyPolicy.s4.n3.title": "3. 本地存储",
  "PrivacyPolicy.s4.n3.p1":
    "App 仅在本地存储非隐私数据，如界面偏好、语言与主题设置。该数据：",
  "PrivacyPolicy.s4.n3.l1": "不上传",
  "PrivacyPolicy.s4.n3.l2": "不同步",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY 不可访问",

  "PrivacyPolicy.s5.title": "5. 数据传输与服务器策略",
  "PrivacyPolicy.s5.l1": "LUKKEY 服务器不存储任何用户信息",
  "PrivacyPolicy.s5.l2": "App 与服务器通信仅用于数据库与版本更新",
  "PrivacyPolicy.s5.l3": "通信过程中不传输任何用户信息",
  "PrivacyPolicy.s5.l4":
    "即便服务器遭入侵，也不会有用户数据泄露，因为我们从未获取此类数据",

  "PrivacyPolicy.s6.title": "6. 开源透明",
  "PrivacyPolicy.s6.l1": "LUKKEY App 源代码开源",
  "PrivacyPolicy.s6.l2": "LUKKEY 硬件嵌入式固件开源",
  "PrivacyPolicy.s6.l3": "在 GitHub 完整公开，欢迎任何人审计",
  "PrivacyPolicy.s6.p": "透明即安全的一部分。",

  "PrivacyPolicy.s7.title": "7. 完整的用户控制权",
  "PrivacyPolicy.s7.p":
    "即使我们不收集用户信息，用户仍然对其设备拥有完全控制权：",
  "PrivacyPolicy.s7.l1": "您可随时关闭 App 权限",
  "PrivacyPolicy.s7.l2": "您可卸载 App 以删除全部本地 App 数据",
  "PrivacyPolicy.s7.l3": "您可重置硬件设备以永久清除私钥与钱包数据",
  "PrivacyPolicy.s7.p2": "LUKKEY 不会也无法干预上述操作。",

  "PrivacyPolicy.s8.title": "8. 联系我们",
  "PrivacyPolicy.s8.p": "如对本隐私政策有任何疑问，请联系：",
  "PrivacyPolicy.s8.email": "邮箱：info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "地址：LUKKEY 总部，Baarerstrasse 25, 6300 Zug, Switzerland",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Checking...",
  "EmailOtp.title": "Restricted Access: Enter email to get a sign-in code",
  "EmailOtp.nameLabel": "Name",
  "EmailOtp.namePlaceholder": "Enter your name",
  "EmailOtp.emailLabel": "Email",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Send Code",
  "EmailOtp.resendCode": "Resend Code",
  "EmailOtp.resendWithCountdown": "Resend ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "The verification code is valid for about 10 minutes",
  "EmailOtp.codeLabel": "Email Verification Code",
  "EmailOtp.codePlaceholder": "Enter the code you received",
  "EmailOtp.signIn": "Sign In",
  "EmailOtp.message.codeSent":
    "验证码已发送，请查收邮箱",
  "EmailOtp.message.devPrinted":
    "开发模式：验证码已打印到服务器控制台",
  "EmailOtp.error.nameRequired": "请输入姓名",
  "EmailOtp.error.invalidEmail": "请输入有效的邮箱地址",
  "EmailOtp.error.sendFailed":
    "验证码发送失败，请稍后再试。",
  "EmailOtp.error.codeRequired": "请输入验证码",
  "EmailOtp.error.verificationFailed": "验证失败",
  "EmailOtp.error.notWhitelisted":
    "该邮箱不在白名单中，请联系管理员。",
  "EmailOtp.error.blacklisted": "该邮箱已被禁止登录。",
  "EmailOtp.error.rateLimited": "请求过于频繁，请稍后再试。",
  "EmailOtp.error.serverError": "服务器错误",
  "EmailOtp.error.invalidOrExpired": "验证码无效或已过期。",
  "EmailOtp.error.expired": "验证码已过期。",
  "EmailOtp.error.incorrect": "验证码不正确。",
  // ===== Academy i18n =====
  "Academy.hero.alert": "安全提醒：警惕钓鱼链接，切勿泄露助记词。",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "学院",
  "Academy.hero.subtitle": "加密安全、自我托管与 LUKKEY 冷钱包使用的实用指南。",
  "Academy.search.placeholder": "搜索教程、最佳实践与常见问题…",
  "Academy.search.hint": "[回车]",
  "Academy.card.type.article": "文章",
  "Academy.list.title": "最新教程",
  "Academy.list.viewAll": "查看全部",
  "Academy.list.empty": "没有结果，试试其他关键词。",
  "Academy.image.placeholder": "图片",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "返回学院",
  "AcademyArticle.notFound": "未找到该文章",
  "AcademyArticle.author": "作者",
  "AcademyArticle.unscheduled": "未安排发布时间",
  "home.hero.reserveCtaLabel": "抢先获得资格 · $1",
  "home.hero.reserveCtaNote": "全额可退。无需作出购买承诺。",
};

export default translation;
